import { common } from '@tencent/ceiba-base-components';
import ruleConfig, { AstTgclub, AstSuperCore, AstSpark } from './ruleConfig';
import Vue from 'vue';
import loginTgclubPluginFunc from './tgclub-plugin-login/login';
import { originLoginFunc as loginSupercorePluginFunc } from './supercore-plugin-login';
import { originLoginFunc as loginSparkPluginFunc } from './spark-plugin-login';
const ruleConfigList = ruleConfig.map(item => JSON.parse(item.value));
const loginPluginFunc = () => {
  const detectAst = common.tool.getRuleValue(Vue.prototype, ruleConfigList);
  console.log('detectAst 检测到的 业务 ast= ', detectAst, Vue.prototype?.$actInfo);
  let loginPluginRes = {};
  if (detectAst === AstTgclub) {
    loginPluginRes = loginTgclubPluginFunc;
  } else if (detectAst === AstSuperCore) {
    loginPluginRes = loginSupercorePluginFunc;
  } else if (detectAst === AstSpark) {
    loginPluginRes = loginSparkPluginFunc;
  } else {
    loginPluginRes = {};
  }
  console.log('------------loginPluginRes-------- ', loginPluginRes);
  return loginPluginRes;
};

export default loginPluginFunc;
export { loginPluginFunc };
